// ClientApp/src/apps/components/tests/SsoAuthVerificationFlow/SsoAuthVerificationFlow.jsx
import PropTypes from "prop-types";
import "./SsoAuthVerificationFlow.css";
import { useNiogemsAuthStatus } from "./hooks/useNiogemsAuthStatus";
import PortalIdentitySection from "./components/PortalIdentitySection";
import NiogemsIdentitySection from "./components/NiogemsIdentitySection";

/**
 * Presentational, data-source-agnostic SSO verification flow.
 * Does NOT call useBogsGisPortalAuth (or any auth hook) itself —
 * the caller is responsible for fetching auth state and passing it
 * down as props. This keeps the component portable and easy to
 * unit test without mocking any specific auth implementation.
 */
export default function SsoAuthVerificationFlow({
  statusMsg,
  portalUser,
  niogemsAuth,
  niogemsLoading,
  fetchNiogemsToken,
  logout,
}) {
  const { approved, denied, parsedPayload } = useNiogemsAuthStatus(niogemsAuth);

  return (
    <div className="sso-auth-flow">
      <h1>SSO Auth Step Verification Flow</h1>
      <hr />

      <PortalIdentitySection statusMsg={statusMsg} portalUser={portalUser} />

      <NiogemsIdentitySection
        niogemsAuth={niogemsAuth}
        niogemsLoading={niogemsLoading}
        portalUserEmail={portalUser?.email}
        isApproved={approved}
        isDenied={denied}
        parsedPayload={parsedPayload}
        onCheckStatus={fetchNiogemsToken}
      />

      <div className="sso-auth-flow__logout-row">
        <button type="button" className="sso-auth-flow__logout-button" onClick={logout}>
          Logout Session
        </button>
      </div>
    </div>
  );
}

SsoAuthVerificationFlow.propTypes = {
  statusMsg: PropTypes.string,
  portalUser: PropTypes.shape({
    fullName: PropTypes.string,
    email: PropTypes.string,
    provider: PropTypes.string,
  }),
  niogemsAuth: PropTypes.shape({
    action: PropTypes.string,
    status: PropTypes.string,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  niogemsLoading: PropTypes.bool,
  fetchNiogemsToken: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

SsoAuthVerificationFlow.defaultProps = {
  statusMsg: null,
  portalUser: null,
  niogemsAuth: null,
  niogemsLoading: false,
};